import React from "react";
import { Box, Card, Typography, useMediaQuery, useTheme } from "@mui/material";
import RainbowDivider from "../../misc/RainbowDivider";

import SebastienFace from "../../../resources/images/png/home/seb.png";
import { ReactComponent as Quotes } from "../../../resources/images/svg/home/subscribe/quotes.svg";
import { ReactComponent as VideoIcon } from "../../../resources/images/svg/home/subscribe/videoIcon.svg";
import { useIsMobile } from "../../../hooks/responsive";

const TestimonialCard = ({ ...props }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF10",
        position: "relative",
        overflow: "visible",
        maxWidth: "1000px",
        mt: isMobile ? 4 : 0,
      }}
    >
      <Quotes
        style={{
          position: "absolute",
          top: "-" + theme.spacing(3),
          left: theme.spacing(7),
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          marginTop: 7,
          marginLeft: 7,
          marginRight: 7,
        }}
      >
        <img
          src={SebastienFace}
          alt="SebastienFace"
          style={{
            width: "95px",
            height: "95px",
          }}
        />
        <Typography
          sx={{
            ml: isMobile ? 0 : 7,
            mt: isMobile ? 2 : 0,
            fontSize: "22px",
            fontStyle: "italic",
            color: "white",
            fontFamily: "Branding Bold",
            fontWeight: 500,
          }}
        >
          Après vingt ans d'exploration du corps et de la conscience, nous sommes appelés à franchir 
          un nouveau cap en nous fédérant autour de valeurs communes, pour continuer de grandir ensemble, 
          vers toujours plus de cohérence et de sagesse.
        </Typography>
      </Box>
      {/*<Box
        sx={{
          display: "flex",
          flexDirection: "row",
          marginTop: theme.spacing(1),
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginBottom: 3,
        }}
      >
        <VideoIcon />
        <a
          href={"#"}
          target="_blank"
          style={{
            marginLeft: theme.spacing(1),
            color: "white",
            fontFamily: "Branding SemiBold",
            textDecoration: "underline",
            fontSize: "18px",
          }}
        >
          Voir la vidéo
        </a>
      </Box>*/}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          paddingRight: 7,
          paddingBottom: 3,
        }}
      >
        <Typography
          sx={{
            fontSize: "18px",
            fontFamily: "Branding SemiBold",
            fontWeight: 500,
            color: "white",
          }}
        >
          - Sébastien Lilli, Fondateur d'Inexploré Praticiens
        </Typography>
      </Box>
      <RainbowDivider />
    </Card>
  );
};

export default TestimonialCard;
